<template>
  <svg
    width="11px"
    height="7px"
    viewBox="0 0 11 7"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>ic-checkmark</title>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-313.000000, -190.000000)" :stroke="color">
        <g transform="translate(310.000000, 185.000000)">
          <polyline points="3.91348788 8.25913371 7 11.2703834 13.0224994 5.247884"></polyline>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
